import { useEffect, useState } from "react";

type RuntimeConfig = {
  turnstile_site_key: string | null;
};

const buildTimeTurnstileSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;

export function useTurnstileSiteKey() {
  const [siteKey, setSiteKey] = useState<string | undefined>(buildTimeTurnstileSiteKey);

  useEffect(() => {
    if (buildTimeTurnstileSiteKey) return;
    let active = true;

    fetch("/api/config", { headers: { Accept: "application/json" } })
      .then((response) => (response.ok ? response.json() : null))
      .then((config: RuntimeConfig | null) => {
        if (!active || !config?.turnstile_site_key) return;
        setSiteKey(config.turnstile_site_key);
      })
      .catch(() => {
        if (active) setSiteKey(undefined);
      });

    return () => {
      active = false;
    };
  }, []);

  return siteKey;
}
